const RAW = (import.meta.env.VITE_AUTHORIZED_EMAILS ?? '').trim();

export const AUTHORIZED_EMAILS: ReadonlyArray<string> = RAW
  ? RAW.split(',').map((e) => e.trim().toLowerCase()).filter(Boolean)
  : [];

export function isEmailAuthorized(email: string | null | undefined): boolean {
  if (!email) return false;
  if (AUTHORIZED_EMAILS.length === 0) return true;
  return AUTHORIZED_EMAILS.includes(email.toLowerCase());
}

if (AUTHORIZED_EMAILS.length === 0 && import.meta.env.DEV) {
  // eslint-disable-next-line no-console
  console.warn(
    '[flashpoint] VITE_AUTHORIZED_EMAILS is empty. Any signed-in Google account will reach the dashboard. Tighten this before deployment.',
  );
}
